export enum DESIGNER_AGENT {
    /**
     * @value Create with Page Writer Agent
     */
    CREATE_WITH_PAGE_WRITER_AGENT = 'CONTRIBUTION_MENU.CREATE_WITH_PAGE_WRITER_AGENT',
    /**
     * @value Let's generate!
     * @description User message to tell the agent to start the generation
     */
    START_GENERATION_USER_MESSAGE = 'DESIGNER_AGENT.START_GENERATION_USER_MESSAGE',
    /**
     * @value Focus updated %WIDGET_NAME% widget
     * @description Button that will highlight and focus the widget that have just been updated by the agent
     */
    WIDGET_UPDATE_REASON_HIGHLIGHT_BUTTON_LABEL = 'DESIGNER_AGENT.WIDGET_UPDATE_REASON_HIGHLIGHT_BUTTON_LABEL',
    /**
     * @value Reason
     * @description Label preceding the update reason of a widget
     */
    WIDGET_UPDATE_REASON_LABEL = 'DESIGNER_AGENT.WIDGET_UPDATE_REASON_LABEL',
}
